<template>
  <div>
    <div v-if="email" class="flex-row gap-xxs align-items-center">
      <i class="mdi mdi-at"/>
      <p class="font-size-md mb-0">
        {{email}}
      </p>
    </div>

    <div v-if="phone" class="flex-row gap-xxs align-items-center">
        <i class="mdi mdi-phone"/>
        <p class="font-size-md mb-0">
            {{phone}}
        </p>
    </div>
    <div v-else style="height: 20px"/>

    <div v-if="mobile" class="flex-row gap-xxs align-items-center">
        <i class="mdi mdi-cellphone"/>
        <p class="font-size-md mb-0">
            {{mobile}}
        </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactInfoCell.vue",
  props: {
    cellProps: {
      type: [String, Number]
    },
    row: {
      type: Object,
      required: true
    },
  },
  computed:{
    email(){
      return this.row.email_address || this.row.email_address_work;
    },
    phone(){
      return this.row.phone;
    },
    mobile(){
      return this.row.phone_mobile;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
